export const initMenuDescriptions = () => {
  const menuItems = document.querySelectorAll(
    '#main-header #et-top-navigation nav li',
  );

  const mobileMenuItems = document.querySelectorAll(
    '.menu-mobile-menu-container .mobile-menu li',
  );

  const processMenuItems = (items) => {
    items.forEach((item) => {
      // Only target sub-menu items
      if (!item.closest('ul.sub-menu')) {
        return;
      }

      const descElement = item.querySelector('.acf-menu-desc');
      if (descElement && descElement.innerHTML.trim() !== '') {
        const link = item.querySelector('a');
        const span = document.createElement('span');
        span.className = 'menu-desc';

        // Allow HTML like <a>, <strong>, etc.
        span.innerHTML = descElement.innerHTML.trim();

        // Insert after the link (not inside)
        if (link) {
          link.insertAdjacentElement('afterend', span);
        } else {
          item.appendChild(span);
        }
      }
    });
  };

  processMenuItems(menuItems);
  processMenuItems(mobileMenuItems);
};
